import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/services/api";
import {
  Mail,
  Lock,
  ArrowRight,
  Sparkles,
} from "lucide-react";

export default function EmbajadorLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.email || !form.password) {
      toast.error("Por favor completa todos los campos");
      return;
    }
    
    setLoading(true);
    try {
      const response = await api.post("/embajadores/login", form);
      
      // Store token and embajador data
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("embajador", JSON.stringify(response.data.embajador));
      localStorage.setItem("userRole", "embajador");
      
      toast.success("¡Bienvenido de nuevo!");
      navigate("/embajador/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Sparkles className="w-4 h-4" />
            Portal de Embajadores
          </div>
          <h1 className="text-3xl font-bold text-gray-900">
            Baruj Shefa
          </h1>
          <p className="text-gray-600 mt-2">Inicia sesión en tu cuenta de embajador</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-3xl shadow-xl p-8 border border-amber-100">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="tu@email.com"
                  className="pl-10 h-12 rounded-xl border-gray-200 focus:border-amber-500 focus:ring-amber-500"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  placeholder="Tu contraseña"
                  className="pl-10 h-12 rounded-xl border-gray-200 focus:border-amber-500 focus:ring-amber-500"
                  required
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-14 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold text-lg rounded-xl shadow-lg shadow-amber-500/20"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  Ingresando...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  Ingresar
                  <ArrowRight className="w-5 h-5" />
                </span>
              )}
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-100 text-center">
            <p className="text-gray-600 text-sm">
              ¿No tienes cuenta?{" "}
              <Link 
                to="/embajador/registro" 
                className="text-amber-600 hover:text-amber-700 font-medium"
              >
                Regístrate como Embajador
              </Link>
            </p>
          </div>
        </div>

        {/* Back to main site */}
        <div className="mt-6 text-center">
          <Link 
            to="/"
            className="text-gray-500 hover:text-gray-700 text-sm"
          >
            ← Volver al sitio principal
          </Link>
        </div>
      </div>
    </div>
  );
}
